export enum FormTab {
  INSTALL,
  ADD,
  LORAWAN_IMPORT
}
